import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useRef } from 'react';
import * as ObjectExtensions from '../../../utils/CoreExtensions/ObjectExtensions';
import useChartExporter from './useChartExporter';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';

// Initialize the NoData module to display no data message
NoDataToDisplay(Highcharts);

const useChart = (props) => {
  const {
    configs = {},
    chartOptions: {
      defaultOptions = {},
      primaryOptions = {}
    }
  } = props

  const chartRef = useRef(null);

  const { chartOptions: exportOptions } = useChartExporter({
    allowExport: configs.export,
    eventName: configs.exportEventName,
    chartProvider: () => (chartRef && chartRef.current.chart)
  });

  const options = ObjectExtensions.orderedDeepMerge(defaultOptions, primaryOptions, exportOptions);

  const highchartsReactOptions = {
    ref: chartRef,
    highcharts: Highcharts,
    options
  }

  const genericOptions = {
    chartRef,
    options
  }

  // This is done to allow the below attributes in label formatting within highcharts to support tooltips
  // ref: https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#filtering
  const whiteListAttributes = ['data-toggle', 'title', 'data-content', 'data-trigger', 'data-html', 'data-text', 'data-placement', 'data-original-title', 'data-container', 'data-template', 'data-delay', 'data-boundary'];
  whiteListAttributes.forEach((attribute) => {
    Highcharts.AST.allowedAttributes.push(attribute);
  });

  return [HighchartsReact, highchartsReactOptions, genericOptions];
}

export default useChart;
